import { useSelector } from 'react-redux';
import { RootState } from '../state/state';
import { UserRoleType } from '../state/user/types';

export const useInternalUser = (): boolean => {
  const userRole = useSelector((state: RootState) => state.user.userInfo?.userRole);
  return !!userRole?.find((role) => role.name !== UserRoleType.Subcontractor);
};
